import advancedFilters from './advancedFilters.json';
import agentBots from './agentBots.json';
import agentMgmt from './agentMgmt.json';
import attributesMgmt from './attributesMgmt.json';
import auditLogs from './auditLogs.json';
import automation from './automation.json';
import bulkActions from './bulkActions.json';
import campaign from './campaign.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import companies from './companies.json';
import components from './components.json';
import contact from './contact.json';
import contactFilters from './contactFilters.json';
import conversation from './conversation.json';
import csatMgmt from './csatMgmt.json';
import customRole from './customRole.json';
import datePicker from './datePicker.json';
import emoji from './emoji.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import helpCenter from './helpCenter.json';
import inbox from './inbox.json';
import inboxMgmt from './inboxMgmt.json';
import integrationApps from './integrationApps.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import contentTemplates from './contentTemplates.json';
import mfa from './mfa.json';
import onboarding from './onboarding.json';
import sessionLimit from './sessionLimit.json';
import yearInReview from './yearInReview.json';
// WIJAYA_CUSTOM_START marine_ai
import marine from '@wijaya/marine_ai/frontend/i18n/marine.json';
// WIJAYA_CUSTOM_END marine_ai
// WIJAYA_CUSTOM_START meta_ads_team_routing
import wijayaMetaAdsRouting from '@wijaya/meta_ads_team_routing/frontend/i18n/wijayaMetaAdsRouting.json';
// WIJAYA_CUSTOM_END meta_ads_team_routing
// WIJAYA_CUSTOM_START erp_lead_sidebar
import wijayaErpSettings from '@wijaya/erp_lead_sidebar/frontend/i18n/wijayaErpSettings.json';
// WIJAYA_CUSTOM_END erp_lead_sidebar

export default {
  ...advancedFilters,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...chatlist,
  ...companies,
  ...components,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...helpCenter,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...snooze,
  ...teamsSettings,
  ...whatsappTemplates,
  ...contentTemplates,
  ...mfa,
  ...onboarding,
  ...sessionLimit,
  ...yearInReview,
  // WIJAYA_CUSTOM_START marine_ai
  ...marine,
  // WIJAYA_CUSTOM_END marine_ai
  // WIJAYA_CUSTOM_START meta_ads_team_routing
  ...wijayaMetaAdsRouting,
  // WIJAYA_CUSTOM_END meta_ads_team_routing
  // WIJAYA_CUSTOM_START erp_lead_sidebar
  ...wijayaErpSettings,
  // WIJAYA_CUSTOM_END erp_lead_sidebar
};
